import { render, staticRenderFns } from "./OrderConfirmedView.vue?vue&type=template&id=a53305ce&"
import script from "./OrderConfirmedView.vue?vue&type=script&lang=ts&"
export * from "./OrderConfirmedView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports